import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function veiculo(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@veiculo/FIND_VEICULO':
      case '@veiculo/UPDATE_VEICULO':
      case '@veiculo/DELETE_VEICULO':
      case '@veiculo/STORE_VEICULO':
      case '@veiculo/VEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@veiculo/SUCCESS_REMOVE':
      case '@veiculo/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@veiculo/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.veiculos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@veiculo/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.veiculo;
        break;
      }

      case '@veiculo/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
